<template>
  <div>
    <vk-modal :stuck="true" class="editFormModal" size="container" :show.sync="modalShow">
      <template v-if="info">
        <ModalContentVue :login="login" :info="info" :type="type" />
      </template>
    </vk-modal>
    <span class="global-button-xs" @click="openModal()"> İncele</span>
  </div>
</template>

<script>
import ModalContentVue from "./AccountDetail/ModalContent.vue";
import EventBus from "../../../components/Ui/EventBus";
import http from "../../../services/http";
export default {
  name: "MetatraderAccounts",
  components: { ModalContentVue },
  data() {
    return {
      accounts: [],
      modalShow: false,
      activeId: null,
      info: null,
      loading: true,
    };
  },
  props: ["id", "type", "login"],
  mounted() {
    EventBus.$on("modalClose", () => {
      this.modalShow = false;
    });
  },
  methods: {
    getPlatformInfo(login) {
      http.mt5.getPlatformInfo({ login, type: this.type }).then((resp) => {
        this.info = resp.data.result;
      });
    },
    openModal() {
      this.getPlatformInfo(this.login);

      this.modalShow = true;
    },
  },
};
</script>
